import axios from '../common/axios';

window.alert = function (message, status = 'error', timeout = 2, position = 'center') {
    const statuss = {
        success: { color: 'white', bg: '#4caf50' },
        error: { color: 'white', bg: '#f44336' },
        warning: { color: 'white', bg: '#ff9800' },
        default: { color: 'white', bg: '#67baff' },
    }
    const positions = {
        "center": { top: '50%', left: '50%', bottom: 'unset' },
        "top-center": { top: '300px', left: '50%', bottom: 'unset' },
        "bottom-center": { bottom: '30px', left: '50%', top: 'unset' },
    }
    if (window.dialog) window.dialog.remove();
    window.dialog = document.createElement('div');
    dialog.innerHTML = `
    <div class="alert-dialog fadein" style="
    color:${statuss[status].color};
    background-color:${statuss[status].bg};
    top:${positions['top-center'].top};
    left:${positions['center'].left};
   
    ">${message}</div>`;
    document.querySelector('body').append(window.dialog);
    window.dialog.addEventListener('click', (e) => {
        window.dialog.firstElementChild.classList.add('fadeout');
        setTimeout(() => { window.dialog.remove(); }, 1000);
    });
    setTimeout(() => {
        window.dialog.firstElementChild.classList.add('fadeout');
        setTimeout(() => { window.dialog.remove(); }, 1000);
    }, timeout * 1000);

}
const to = async (promise) => {
    try {
        const response = await promise;
        // console.log("Was in to 2", re);

        return response;
    } catch (error) {
        //Check statut
       // console.log('error--------',error.response.data)
        alert(error.response ? error.response.data : error.message)
        if(error.response && error.response.data === 'Login failed please try again'){
            window.localStorage.removeItem('id_token');
            window.location.href = '/';
        }
        return {}
    }
};


export default {
    //working
    get: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/get`, { params: payload }))
        if (!data) return null
        return data;
    },
    search: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/search`, { params: payload }))
        // console.log("kan hna", data)
        if (!data) return null
        return data;
    },
    bigSearch: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/search`, payload))
        // console.log("kan hna", data)
        if (!data) return null
        return data;
    },
    //working
    create: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/create`, payload))
        if (!data) return null
        return data;
    },
    insertMany: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/insertMany`, payload))
        if (!data) return null
        return data;
    },
    // working
    update: async function (module, payload) {
        const { data } = await to(axios.put(`${module}/update?_id=${payload._id}`, payload))
        if (!data) return null
        return data;
    },
    updateMany: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/updateMany`, payload))
        if (!data) return null
        return data;
    },
    deleteMany: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/deleteMany`, payload))
        if (!data) return null
        return data;
    },
    getOrdersByseller: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/getOrdersByseller`, payload))
        if (!data) return null
        return data;
    },
    //working
    delete: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/delete`, { params: payload }))
        if (!data) return null
        return data;
    },
    find: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/find`, { params: payload }))
        if (!data) return null
        return data;
    },
    login: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/login`, payload))
        if (!data) return null
        return data;
    },
    // Programme de parrainage — dispatcher RPC: affiliation('users', { getAffiliateInfo: true, ... })
    affiliation: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/affiliation`, payload))
        if (!data) return null
        return data;
    },
    // Public — vérifier un code de parrainage (landing / inscription)
    validateReferralCode: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/validateReferralCode`, payload))
        if (!data) return null
        return data;
    },
    generateToken: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/generateToken`, payload))
        if (!data) return null
        return data;
    },
    forgotPassword: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/forgotPassword`, payload))
        if (!data) return null
        return data;
    },
    verificationCode: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/verificationCode`, payload))
        if (!data) return null
        return data;
    },
    verificationCodeSms: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/verificationCodeSms`, payload))
        if (!data) return null
        return data;
    },
    me: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/me`, { params: payload }))
        if (!data) return null
        return data;
    },
    import: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/import`, payload))
        if (!data) return null;
        return data;
    },
    // generic POST to /:module/:action  (used by auto-confirm scoring / quality)
    action: async function (module, action, payload) {
        const { data } = await to(axios.post(`${module}/${action}`, payload))
        if (!data) return null
        return data;
    },
    confirmation: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/confirmation`, { params: payload }))
        if (!data) return null
        return data;
    },
    export: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/export`, { params: payload }))
        if (!data) return null
        return data;
    },
    convert: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/convert`, payload))
        if (!data) return null
        return data;
    },
    reject: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/reject`, payload))
        if (!data) return null
        return data;
    },

    getOrders: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getOrders`, { params: payload }))
        if (!data) return null
        return data;
    },
    getRevenus_and_TopProducts_Stock: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getRevenus_and_TopProducts_Stock`, { params: payload }))
        if (!data) return null
        return data;
    },
    getOrdersBetweenTwoDate: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getOrdersBetweenTwoDate`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrders: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrders`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalSeller: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalSeller`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalProduct: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalProduct`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrdersPerTeleConsultant: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrdersPerTeleConsultant`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrdersTeleConsultant: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrdersTeleConsultant`, { params: payload }))
        if (!data) return null
        return data;
    },
    getOrdersTeleConsultantBetweenTwoDate: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getOrdersTeleConsultantBetweenTwoDate`, { params: payload }))
        if (!data) return null
        return data;
    },
    CalculatePercentageStaus: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/CalculatePercentageStaus`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalOrdersPaid: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalOrdersPaid`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalStatusPerTeleconsultantBetweenTwoDate: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalStatusPerTeleconsultantBetweenTwoDate`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalStatusPerTeleconsultant: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalStatusPerTeleconsultant`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalDelivery: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalDelivery`, { params: payload }))
        if (!data) return null
        return data;
    },
    getConfirmationStatus: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getConfirmationStatus`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAllSeller: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAllSeller`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTotalFeesExpeditions: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTotalFeesExpeditions`, { params: payload }))
        if (!data) return null
        return data;
    },
    // Auto-Confirm analytics
    getAutoConfirmAnalytics: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAutoConfirmAnalytics`, { params: payload }))
        if (!data) return null
        return data;
    },
    listAutoConfirmedOrders: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/listAutoConfirmedOrders`, { params: payload }))
        if (!data) return null
        return data;
    },
    computeAutoConfirmPresets: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/computeAutoConfirmPresets`, { params: payload }))
        if (!data) return null
        return data;
    },
    previewAutoConfirmProfiles: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/previewAutoConfirmProfiles`, { params: payload }))
        if (!data) return null
        return data;
    },
    hasAutoConfirmHistory: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/hasAutoConfirmHistory`, { params: payload }))
        if (!data) return null
        return data;
    },
    sendEmail: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/sendEmail`, payload))
        if (!data) return null
        return data;
    },
    // Product Attributes methods (intégrés dans le module products)
    searchAttributes: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/searchAttributes`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAttribute: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAttribute`, { params: payload }))
        if (!data) return null
        return data;
    },
    createAttribute: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/createAttribute`, payload))
        if (!data) return null
        return data;
    },
    updateAttribute: async function (module, payload) {
        const { data } = await to(axios.put(`${module}/updateAttribute?_id=${payload._id}`, payload))
        if (!data) return null
        return data;
    },
    deleteAttribute: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/deleteAttribute`, { params: payload }))
        if (!data) return null
        return data;
    },
    addAttributeValue: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/addAttributeValue`, payload))
        if (!data) return null
        return data;
    },
    removeAttributeValue: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/removeAttributeValue`, payload))
        if (!data) return null
        return data;
    },
    // Seller Team methods
    getTeamMembers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTeamMembers`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTeamMember: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTeamMember`, { params: payload }))
        if (!data) return null
        return data;
    },
    addTeamMember: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/addTeamMember`, payload))
        if (!data) return null
        return data;
    },
    updateTeamMember: async function (module, payload) {
        const { data } = await to(axios.put(`${module}/updateTeamMember?_id=${payload._id}`, payload))
        if (!data) return null
        return data;
    },
    removeTeamMember: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/removeTeamMember`, { params: payload }))
        if (!data) return null
        return data;
    },
    resendInvitation: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/resendInvitation`, payload))
        if (!data) return null
        return data;
    },
    getTeamStats: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTeamStats`, { params: payload }))
        if (!data) return null
        return data;
    },
    // Agent Assignments methods
    getAssignments: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAssignments`, { params: payload }))
        if (!data) return null
        return data;
    },
    getMyAssignment: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMyAssignment`, { params: payload }))
        if (!data) return null
        return data;
    },
    createAssignment: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/createAssignment`, payload))
        if (!data) return null
        return data;
    },
    updateAssignment: async function (module, payload) {
        const { data } = await to(axios.put(`${module}/updateAssignment?_id=${payload._id}`, payload))
        if (!data) return null
        return data;
    },
    deleteAssignment: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/deleteAssignment`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAvailableAgents: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAvailableAgents`, { params: payload }))
        if (!data) return null
        return data;
    },
    getCouriers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getCouriers`, { params: payload }))
        if (!data) return null
        return data;
    },
    addCourier: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/addCourier`, payload))
        if (!data) return null
        return data;
    },
    removeCourier: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/removeCourier`, payload))
        if (!data) return null
        return data;
    },
    updateCourierSchedule: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/updateCourierSchedule`, payload))
        if (!data) return null
        return data;
    },
    // Agent Dashboard methods
    getMyShippings: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMyShippings`, { params: payload }))
        if (!data) return null
        return data;
    },
    getDashboardStats: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getDashboardStats`, { params: payload }))
        if (!data) return null
        return data;
    },
    getShippingDetails: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getShippingDetails`, { params: payload }))
        if (!data) return null
        return data;
    },
    getMyCouriers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMyCouriers`, { params: payload }))
        if (!data) return null
        return data;
    },
    changeStatus: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/changeStatus`, payload))
        if (!data) return null
        return data;
    },
    // Follow-up Actions methods
    createAction: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/createAction`, payload))
        if (!data) return null
        return data;
    },
    addNote: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/addNote`, payload))
        if (!data) return null
        return data;
    },
    getShippingHistory: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getShippingHistory`, { params: payload }))
        if (!data) return null
        return data;
    },
    // Account Manager methods
    getDashboard: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getDashboard`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAssignedSellers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAssignedSellers`, { params: payload }))
        if (!data) return null
        return data;
    },
    getSellerStats: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getSellerStats`, { params: payload }))
        if (!data) return null
        return data;
    },
    getTopSellers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getTopSellers`, { params: payload }))
        if (!data) return null
        return data;
    },
    assignSeller: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/assignSeller`, payload))
        if (!data) return null
        return data;
    },
    unassignSeller: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/unassignSeller`, { params: payload }))
        if (!data) return null
        return data;
    },
    bulkAssignByCountry: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/bulkAssignByCountry`, payload))
        if (!data) return null
        return data;
    },
    getUnassignedSellers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getUnassignedSellers`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAccountManagers: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAccountManagers`, { params: payload }))
        if (!data) return null
        return data;
    },
    // Conversations methods
    getMyConversations: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMyConversations`, { params: payload }))
        if (!data) return null
        return data;
    },
    getConversation: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getConversation`, { params: payload }))
        if (!data) return null
        return data;
    },
    getOrCreateConversation: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/getOrCreateConversation`, payload))
        if (!data) return null
        return data;
    },
    markAsRead: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/markAsRead`, payload))
        if (!data) return null
        return data;
    },
    getUnreadCount: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getUnreadCount`, { params: payload }))
        if (!data) return null
        return data;
    },
    archiveConversation: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/archiveConversation`, payload))
        if (!data) return null
        return data;
    },
    getUnansweredAlerts: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getUnansweredAlerts`, { params: payload }))
        if (!data) return null
        return data;
    },
    resolveAlert: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/resolveAlert`, payload))
        if (!data) return null
        return data;
    },
    // Messages methods
    getMessages: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMessages`, { params: payload }))
        if (!data) return null
        return data;
    },
    sendMessage: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/sendMessage`, payload))
        if (!data) return null
        return data;
    },
    uploadFile: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/uploadFile`, payload))
        if (!data) return null
        return data;
    },
    deleteMessage: async function (module, payload) {
        const { data } = await to(axios.delete(`${module}/deleteMessage`, { params: payload }))
        if (!data) return null
        return data;
    },
    getMessageCount: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMessageCount`, { params: payload }))
        if (!data) return null
        return data;
    },
    // Stockist Dashboard methods
    getPackagesToAssign: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getPackagesToAssign`, { params: payload }))
        if (!data) return null
        return data;
    },
    assignToCourier: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/assignToCourier`, payload))
        if (!data) return null
        return data;
    },
    reassignPackage: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/reassignPackage`, payload))
        if (!data) return null
        return data;
    },
    getPendingReturns: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getPendingReturns`, { params: payload }))
        if (!data) return null
        return data;
    },
    validateReturn: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/validateReturn`, payload))
        if (!data) return null
        return data;
    },
    getMyStats: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getMyStats`, { params: payload }))
        if (!data) return null
        return data;
    },
    getAssignmentHistory: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/getAssignmentHistory`, { params: payload }))
        if (!data) return null
        return data;
    },
    checkAssignmentLock: async function (module, payload) {
        const { data } = await to(axios.get(`${module}/checkAssignmentLock`, { params: payload }))
        if (!data) return null
        return data;
    },
    configureSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/configureSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
    testSellerWebhook: async function (module, payload) {
        const { data } = await to(axios.post(`${module}/testSellerWebhook`, payload))
        if (!data) return null
        return data;
    },
}